import React from "react";
import styles from "./Styles.module.css";
import { setCommentaryAction } from "../../Redux/Case-reducer";
import { useDispatch, useSelector } from "react-redux";
import { setCommentary } from "../../DAL/dal";

const Commentary = ({ type, header, clouse, id, devMode }) => {
  const dispatch = useDispatch();
  const {
    surveyPlan,
    principalDiagnosis,
    treatment,
    progressionFactors,
    futureTreatment,
    alpha_adrenoblocker,
  } = useSelector((state) => state.currentCase);

  const onTyping = (e) => {
    dispatch(setCommentaryAction(type, e.target.value));
  };

  const sendIntermediateCommentary = (id, key) => {
    // внутри себя решает куда отправить комментарий
    if (key == "survey-plan") setCommentary(surveyPlan.commentary, id, key);
    if (key == "diagnosis")
      setCommentary(principalDiagnosis.commentary, id, key);
    if (key == "factors") setCommentary(progressionFactors.commentary, id, key);
    if (key == "treatment") setCommentary(treatment.commentary, id, key);
    if (key == "future-treatment")
      setCommentary(futureTreatment.commentary, id, key);
    if (key == "alpha-adrenoblocker")
      setCommentary(alpha_adrenoblocker.commentary, id, key);
  };

  return (
    <>
      <h2>{header}</h2>
      <textarea
        className={styles.textarea}
        rows="10"
        name="commentary"
        id="1"
        onChange={onTyping}
        value={
          type == "survey-plan"
            ? surveyPlan.commentary
            : type == "diagnosis"
            ? principalDiagnosis.commentary
            : type == "factors"
            ? progressionFactors.commentary
            : type == "future-treatment"
            ? futureTreatment.commentary
            : type == "alpha-adrenoblocker"
            ? alpha_adrenoblocker.commentary
            : treatment.commentary
        }
      ></textarea>
      <button
        onClick={() => {
          if (!devMode) sendIntermediateCommentary(id, type);
          clouse(false);
        }}
        className="buttonBack"
        style={{ marginTop: "10px" }}
      >
        Ок
      </button>
    </>
  );
};

export default Commentary;
